import { render } from "./Sidebar.vue?vue&type=template&id=fb26013a&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=fb26013a&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=fb26013a&scoped=true&lang=css"

import exportComponent from "E:\\dipto_projects\\parcel\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb26013a"]])

export default __exports__